import PolyDataType from './poly-data-type.js';
class PolyData {
    polyDataType;
    name = 'PolyData';
    numberOfPoints;
    points;
    verticesBufferSize;
    vertices;
    linesBufferSize;
    lines;
    polygonsBufferSize;
    polygons;
    triangleStripsBufferSize;
    triangleStrips;
    numberOfPointPixels;
    pointData;
    numberOfCellPixels;
    cellData;
    constructor(polyDataType = new PolyDataType()) {
        this.polyDataType = polyDataType;
        this.polyDataType = polyDataType;
        this.name = 'PolyData';
        this.numberOfPoints = 0;
        this.points = new Float32Array();
        this.verticesBufferSize = 0;
        this.vertices = null;
        this.linesBufferSize = 0;
        this.lines = null;
        this.polygonsBufferSize = 0;
        this.polygons = null;
        this.triangleStripsBufferSize = 0;
        this.triangleStrips = null;
        this.numberOfPointPixels = 0;
        this.pointData = null;
        this.numberOfCellPixels = 0;
        this.cellData = null;
    }
}
export default PolyData;
//# sourceMappingURL=poly-data.js.map